import React, { useState } from 'react';
import { Link } from "react-router-dom";

import freelancer from '../../assets/images/freelancer.png'
import freelancer2 from '../../assets/images/freelancer.jpg'
import bgLine from '../../assets/images/bg/bg-lines-two.png'

import Navbar from "../../components/navbar";
import Blog from '../../components/blog';
import Footer from '../../components/footer';
import ScrollTop from '../../components/scrollTop';

import ModalVideo from 'react-modal-video';
import '../../../node_modules/react-modal-video/scss/modal-video.scss';

import TinySlider from "tiny-slider-react";
import 'tiny-slider/dist/tiny-slider.css';

import CountUp from 'react-countup';

import { clientData, counterData, freelancerAbout, freelancerOffer, portfolioData } from '../../data/data';

export default function IndexFreelancer(){
    let [isOpen, setOpen] = useState(false);
    let settings2 = {
        container: '.tiny-single-item',
        items: 1,
        controls: false,
        mouseDrag: true,
        loop: true,
        rewind: true,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 3000,
        navPosition: "bottom",
        speed: 400,
        gutter: 16,
        responsive: {
            992: {
                items: 5
            },

            767: {
                items: 2
            },
            

            320: {
                items: 1
            },
        },
      };
    let settings ={
        container: '.tiny-two-item',
        controls: false,
        mouseDrag: true,
        loop: true,
        rewind: true,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 3000,
        navPosition: "bottom",
        speed: 400,
        gutter: 12,
        responsive: {
            992: {
                items: 2
            },

            767: {
                items: 2
            },

            320: {
                items: 1
            },
        },
    }  
    return(
        <>
        <Navbar/>

        <section className="bg-hero pb-0 bg-light home-wrapper d-table w-100 overflow-hidden">
            <div className="container">
                <div className="row mt-5 align-items-center">
                    <div className="col-md-6">
                        <div className="heading-title">
                            <h4>Product Designer</h4>
                            <h4 className="display-3 fw-bold mb-4">Andrea George</h4>
                            <p className="text-muted para-desc mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        
                            <div className="mt-4 align-items-center">
                                <Link to="#" className="btn btn-primary">View Portfolio</Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                        <img src={freelancer} className="img-fluid" alt=""/>
                    </div>
                    
                </div>
            </div>
        </section>
        <div className="position-relative">
            <div className="shape overflow-hidden text-white">
                <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>

        <section className="section" id="about">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-md-6 col-12">
                        <div className="position-relative">
                            <img src={freelancer2} className="img-fluid rounded shadow-md" alt=""/>
                            <div className="play-icon">
                                <Link to="#"  onClick={() => setOpen(true)} className="lightbox play-btn video-play-icon">
                                    <i className="mdi mdi-play text-primary rounded-circle bg-white shadow"></i>
                                </Link>
                            </div>
                            <ModalVideo
                                channel="youtube"
                                youtube={{ mute: 0, autoplay: 0 }}
                                isOpen={isOpen}
                                videoId="yba7hPeTSjk"
                                onClose={() => setOpen(false)} 
                            />
                        </div>
                    </div>

                    <div className="col-lg-7 col-md-6 col-12 mt-4 pt-2 mt-sm-0 pt-sm-0">
                        <div className="ms-lg-5">
                            <div className="section-title">
                                <span className="badge rounded-pill bg-soft-primary h6">About Me</span>
                                <h4 className="title fw-bold mt-2 mb-4">Better Design <br/> Better Experience</h4>
                                <p className="para-desc text-muted">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                            </div>
                            {freelancerAbout.map((item, index) =>{
                                return(
                                    <div className="progress-box mt-4" key={index}>
                                        <h6 className="title text-muted">{item.title}</h6>
                                        <div className="progress">
                                            <div className="progress-bar position-relative bg-primary" style={{width:item.progress}}>
                                                <div className="progress-value d-block text-muted h6">{item.progress}</div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h4 className="title mt-3 mb-4">What i offer ?</h4>
                            <p className="para-desc mx-auto text-muted mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    {freelancerOffer.map((item, index) =>{
                        let Icon = item.icon
                        return(
                            <div className="col-lg-4 col-md-6 mt-4 pt-3" key={index}>
                                <div className="card border-0 text-center features feature-primary">
                                    <div className="icon text-center mx-auto rounded-md">
                                        <h3 className="mb-0"><Icon/></h3>
                                    </div>

                                    <div className="card-body p-0 mt-4">
                                        <h5>{item.title}</h5>
                                        <p className="text-muted mb-0">{item.desc}</p>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>

        <section className="section bg-light">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="section-title mb-4 pb-2">
                            <span className="badge rounded-pill bg-soft-primary h6">Portfolio</span>
                            <h4 className="title mt-2 mb-4">Latest Projects & Works</h4>
                            <p className="para-desc text-muted mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid mt-4 pt-2" id="slider-container">
                <div className="row slider-row-width">
                    <div className="col-12">
                        <div className="swiper-container">
                            <div className="swiper-wrapper">
                                <TinySlider settings={settings2}>
                                    {portfolioData.map((item, index) =>{
                                        return(
                                        <div className="swiper-slide" key={index}>
                                            <div className={item.borderClass}>
                                                <div className="card-body p-0">
                                                    <Link to="#"><img src={item.image} className="img-fluid work-image" alt=""/></Link>
                                                    <div className="content p-4">
                                                        <h5 className="mb-0"><Link to="#" className="text-dark title">{item.title}</Link></h5>
                                                        <h6 className="text-muted tag mb-0">{item.desc}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        )
                                    })}
                                </TinySlider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="py-5 bg-primary" style={{backgroundImage:`url(${bgLine})`, backgroundPosition:'center'}}>
            <div className="container">
                <div className="row" id="counter">
                    {counterData.map((item, index) =>{
                        let Icon = item.icon
                        return(
                            <div className="col-lg-3 col-6" key={index}>
                                <div className="counter-box rounded py-3 text-center">
                                    <div className="counter-icon">
                                        <Icon className="fea icon-md text-white-50"/>
                                    </div>
                                    <h3 className="counter-value mt-3 text-white title-dark" data-target="1251"><CountUp start={0} end={item.target}/></h3>
                                    <h6 className="counter-head fw-normal mb-0 text-white-50 title-dark">{item.title}</h6>
                                </div>
                            </div>
                        )   
                    })}
                </div>
            </div>
        </section>

        <section className="section">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h4 className="title mb-4">Client's Review</h4>
                            <p className="para-desc mx-auto text-muted mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 mt-4 pt-2">
                        <div className="tiny-two-item">
                            <TinySlider settings={settings}>
                                {clientData.map((item, index) =>{
                                    return(
                                        <div className="tiny-slide" key={index}>
                                            <div className="card border-0 customer-testi p-4 pt-5 shadow rounded-md m-2 overflow-hidden">
                                                <p className="text-muted fst-italic">{item.desc}</p>

                                                <div className="d-flex align-items-center mt-3">
                                                    <img src={item.image} className="img-fluid avatar avatar-small rounded-circle shadow" alt=""/>
                                                    <div className="flex-1 ms-3">
                                                        <h6 className="text-primary mb-0">{item.name}</h6>
                                                        <small className="text-muted">{item.title}</small>
                                                    </div>
                                                </div>
                                                <div className="quote">
                                                    <i className="mdi mdi-format-quote-close"></i>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </TinySlider>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h4 className="title mb-4">Latest News or Blogs</h4>
                            <p className="text-muted para-desc mx-auto mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>
                <Blog/>
            </div>
        </section>
        <Footer/>
        <ScrollTop/>
        </>
    )
}